export default "__VITE_ASSET__DjqIR$Zc__"